import Layout from "../../Layout"

const PowerBI = () => {
  return (
    <Layout>
      <div></div>
    </Layout>
  )
}

export default PowerBI
